import { useState, useEffect } from "react";
import * as THREE from "three";
import { Vector3  } from "three";
import {
  ACESFilmicToneMapping } from "three";
import { createPointGrid } from "../util/createPointGrid";

export default function useSceneManager(inH, inW) {
  const [renderer, setRenderer] = useState();
  const [scene, setScene] = useState();
  const [camera, setCamera] = useState();
  const [planeGrid, setPlaneGrid] = useState()
  useEffect(() => {
   
if(inH && inW) {
    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
      renderer.xr.enabled = true;

      renderer.outputEncoding = THREE.SRGBColorSpace;
      renderer.shadowMap.enabled = true
      renderer.shadowMap.type = THREE.PCFSoftShadowMap;
      renderer.toneMapping = ACESFilmicToneMapping;
      renderer.toneMappingExposure = 2;

      renderer.setSize(inW, inH);

   setRenderer(renderer);
      //CREATE SCENE
      const scene = new THREE.Scene();
      console.log('scene 1', scene)
      setScene(scene);

      //Camera
    const camera = new THREE.PerspectiveCamera(
      70,
      inW/ inH,
      0.01,
      100
    );
    camera.position.z = 3;
    setCamera(camera)
    // const geometry = new THREE.BoxGeometry(0.5, 0.5, 0.5);
    // const material = new THREE.MeshNormalMaterial();
    // const cube = new THREE.Mesh(geometry, material);
    // cube.name="arCubeL"
    // cube.visible = false
    // scene.add(cube);

    // const planeGrid = createPointGrid(1, 1, 10); // width=1m, depth=1m, 10 divisions
    // setPlaneGrid(planeGrid)
    // scene.add(planeGrid);
   

    renderer.render(scene, camera)
    function animate() {
      requestAnimationFrame(animate);

         renderer.render(scene, camera);
    }
    animate();

    return () => {
      
      renderer.dispose();
      
    };}
  }, [inH, inW]);

  return {renderer, scene, camera, /*planeGrid*/};
}
